import { NEXT_IMAGE_QUALITY } from "@/constants";
import { useGetWalletLatestEarnings } from "@/hooks/api";
import { useConnection } from "@/hooks/connection";
import { trackLegacyEvent } from "@analytics";
import { Box, HeroCard } from "@biom3/react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";

const OnboardingPageBanner = () => {
  const router = useRouter();
  const { walletAddress } = useConnection();
  const { latestEarnings } = useGetWalletLatestEarnings(
    walletAddress ?? undefined,
  );

  const handleGetStarted = useCallback(() => {
    router.push("/games/immutable-play-onboarding");
    trackLegacyEvent({
      screen: "OnboardingBanner",
      userJourney: "Onboarding",
      control: "GetStarted",
      controlType: "Button",
      action: "Pressed",
    });
  }, [router.push]);

  // Hide banner if wishlist earning for the onboarding 'game' is completed
  const isCompleted = latestEarnings?.earnings.some(
    (earning) =>
      (earning.ruleId as string) ===
      "457d23e1-dede-46a1-87ea-02b495e664bd-wishlist",
  );

  if (isCompleted) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: "base.spacing.x6",
      }}
    >
      <HeroCard
        sx={{
          background: "base.color.translucent.inverse.800",
          height: ["270px", "270px", "245px", "216px"],
          position: "relative",
          padding: ["base.spacing.x4", "base.spacing.x6"],
        }}
        aspectRatio="unset"
      >
        <HeroCard.AssetImage
          loading="eager"
          use={
            <Image
              src="/images/quests/onboarding-banner-bg.png"
              alt="Get started on Immutable Play"
              fill
              priority
              quality={NEXT_IMAGE_QUALITY}
              style={{
                objectFit: "cover",
                objectPosition: "center right",
              }}
            />
          }
        />

        {/* Desktop Steam Deck Image - positioned absolutely */}
        <Box
          sx={{
            position: "absolute",
            right: ["base.spacing.x4", "base.spacing.x6", "base.spacing.x8"],
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 2,
            width: ["200px", "240px"],
            height: ["auto"],
            pointerEvents: "none",
            display: ["none", "none", "none", "block"],
          }}
        >
          <Image
            src="/images/steam-deck-full.webp"
            alt="Steam Deck"
            width={240}
            height={150}
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>

        <HeroCard.Title
          size={["medium", "medium", "medium", "large"]}
          sx={{
            maxWidth: ["100%", "100%", "100%", "70%"],
            zIndex: 3,
            position: "relative",
          }}
        >
          Start tutorial, enter draw for a Steam Deck
        </HeroCard.Title>
        <HeroCard.Button
          size="medium"
          rc={<Link href="/games/immutable-play-onboarding" />}
          onClick={handleGetStarted}
          sx={{
            zIndex: 3,
            position: "relative",
          }}
        >
          Start Here
        </HeroCard.Button>
      </HeroCard>
    </Box>
  );
};

export default OnboardingPageBanner;
